// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
const currentYear = siteData.current_year

class Footer extends React.Component {
	render() {
		return (
			<footer className="footer">
				<div className="-inner">
					<div className="-a">
						<p>
							P.O. Box 4368, Ringwood VIC 3134, Australia<br />
							PH: 1800 324 843 (1800 FAITHFM) &nbsp;&middot;&nbsp;&nbsp;<a href="mailto:info@faithfm.com.au">Email&nbsp;Us</a> &nbsp;&middot;&nbsp;&nbsp;<a href="/privacy">Privacy</a>
						</p>

						<p>
							Copyright &copy; { currentYear } Faith FM
							<br />
							Website by <a className="plain" href="https://alexgreendesign.com" target="_blank">Alex Green Design</a>
						</p>
					</div>

					<div className="-b">
						<a className="-logo-adventist-australia" href="https://adventist.org.au/" target="_blank" rel="noopener">
							<img src={ siteData.images_url + 'logo/adventist_church_in_auc_text_vertical_charcoal.svg' } alt="Adventist Church in Australia" />
						</a>

						<a className="-logo-awr" href="http://www.awr.org/" target="_blank" rel="noopener">
							<img src={ siteData.images_url + 'logo/awr-grey.svg' } alt="Adventist World Radio" />
						</a>
					</div>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Footer )
